const MAX_LENGTH = 24

export function truncateMessage(message: string): string {
  if (message.length <= MAX_LENGTH) {
    return message
  }

  return `${message.slice(0, MAX_LENGTH)}…`
}
